import React from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { TreeView } from '@lexical/react/LexicalTreeView';
const TreeViewPlugin = () => {
  const [editor] = useLexicalComposerContext();
  return /*#__PURE__*/React.createElement(TreeView, {
    viewClassName: "tree-view-output",
    editor: editor
  });
};
export default TreeViewPlugin;